export default "__VITE_ASSET__Bw76ZjvQ__"